module.exports = __webpack_public_path__ + "img/05_blue_talking.7ce4c2ab.gif";